import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { IDocumentForSign, IDocumentVersion } from '@senet-uiverse/common';
import { NbButtonModule, NbIconModule } from '@nebular/theme';
import { SenetDocumentsPipe } from '@senet-id/shared/pipes';
import SenetIdUniversalClass from '@senet-id/universal';
import { TranslateModule } from '@ngx-translate/core';
import { tap } from 'rxjs';

import { LanguageComponent } from './language';

@Component({
  selector: 'sid-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NbButtonModule, NbIconModule, LanguageComponent, SenetDocumentsPipe],
  host: { class: 'block fixed bottom-0 left-0 right-0 z-10' },
})
export class FooterComponent extends SenetIdUniversalClass {
  protected readonly userGroup = this.documentsService.userGroup;
  protected readonly orgLang = this.organizationService.orgLang;
  protected readonly docs = signal<IDocumentVersion[]>([]);
  protected readonly year = new Date().getFullYear();

  constructor() {
    super();

    this.getSenetDocuments();
  }

  protected openDocument(document: IDocumentForSign) {
    this.documentsService.openDocument(document).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  private getSenetDocuments() {
    this.documentsService
      .getSenetDocuments()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((response) => this.docs.set(response)),
      )
      .subscribe();
  }
}
